import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.m47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.n47_1 = LinkedHashMap().ec();
      }
      o47() {
        return this.n47_1;
      }
      n3y() {
        // Inline function 'kotlin.apply' call
        this.m47_1.n3y();
        return this;
      }
      o3y() {
        // Inline function 'kotlin.apply' call
        this.m47_1.o3y();
        return this;
      }
      f3y() {
        // Inline function 'kotlin.apply' call
        this.m47_1.f3y();
        return this;
      }
      g3y() {
        // Inline function 'kotlin.apply' call
        this.m47_1.g3y();
        return this;
      }
      n4a(name) {
        // Inline function 'kotlin.apply' call
        this.m47_1.n4a(name);
        return this;
      }
      u3y(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.u3y(value);
        return this;
      }
      e3z(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.e3z(value);
        return this;
      }
      z3y(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.z3y(value);
        return this;
      }
      w3y(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.w3y(value);
        return this;
      }
      c3z(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.c3z(value);
        return this;
      }
      p4a(value) {
        // Inline function 'kotlin.apply' call
        this.m47_1.p4a(value);
        return this;
      }
      j3z(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.n47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.m47_1.d4a();
        tmp0.x4(key, value);
        this.m47_1.y3x();
        return this;
      }
      y3x() {
        // Inline function 'kotlin.apply' call
        this.m47_1.y3x();
        return this;
      }
      d4a() {
        return this.m47_1.d4a();
      }
      l6() {
        this.m47_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
